<template>
    <div class="connect-your-works">
        <div class="container py-8 ">
            <div class="flex py-16">
                <div class="w-full">
                    <h1 class="font-bold text-3xl md:text-6xl text-white uppercase text-center mb-5">Verdensmål</h1>
                    <p class="font-bold text-3xl md:text-6xl text-white uppercase text-center">Her kan du se de Verdensmål, du har valgt at støtte</p>
                </div>
            </div>
            <div class="flex flex-col p-4 md:p-16 bg-white">
                <div v-for="(item, index) in contentInterestUsersArray" :key="item.interest_user.id"  :class="['w-full mb-5', { active: index === 0 }]"  ref="card" :data-id="item.interest_id">
                    <div  class="card" >
                        <div class="card-header pb-5 border-b border-b-2 border-[#FF00A8] cursor-pointer" @click="toggleCardBody(item.interest_id)">
                            <div class="flex items-end gap-6">
                                <img :src="'/img/interests/' + item.interest.id + '.png'" class="card-img-top" alt="Interest Image">
                                <div class="card-title uppercase flex items-center gap-2">
                                    <img class="pledge-icon w-8 h-8" src="/img/interests-icon.png" alt="">
                                    <span class="uppercase text-base text-[#FF00A8] font-black">{{ item.interest.name }}</span>
                                </div>
                            </div>
                        </div>
                        
                        <div v-show="visibleCard === item.interest_id" class="card-body py-5 pb-14">
                            <div v-if="!item.content || item.content.length === 0" class="flex gap-3 text-base">
                                No work about this verdensmål, connect your work now!
                                <button class="btn btn-load btn-success" @click="openModal(item)">Connect Post</button>
                            </div>

                            <!-- Check if there is content -->
                            <ul class="flex flex-wrap" v-else>
                                <li v-for="content in item.content" :key="content.id">
                                    <div class="wrapper-img">
                                        <img :src="content.cached_media_image || content.media_image" alt="Content image">
                                    </div>
                                    <div v-if="hasLikes(content) || hasStats(content)" class="p-2">
                                        <div v-if="hasLikes(content)" class="flex justify-between text-sm">
                                            <div>
                                                <i v-if="content.latest_stat.likes > 0" class="fa fa-heart text-red-500"></i>
                                                <i v-else="" class="fa fa-heart-o text-red-500"></i>
                                                <span v-text="content.latest_stat.likes"></span>
                                            </div>
                                            <div>
                                                <i v-if="content.latest_stat.comments > 0" class="fa fa-comment text-red-500"></i>
                                                <i v-else="" class="fa fa-comment-o text-red-500"></i>
                                                <span v-text="content.latest_stat.comments"></span>
                                            </div>
                                        </div>

                                        <template v-if="hasStats(content)">
                                            <span
                                                v-for="stat of getStats(content)"
                                                :key="stat.label"
                                                class="flex mt-1 text-xs opacity-75 text-left"
                                            >
                                                <span class="flex-1" v-text="stat.label"></span>
                                                <span v-text="stat.value"></span>
                                            </span>
                                        </template>
                                    </div>

                                </li>
                            </ul>
                            <div v-if="item.content.length !== 0"  class="flex gap-3 text-base mt-8">
                                <button class="btn btn-load btn-success" @click="openModal(item)">Connect Post</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <LinkContentModal
                v-if="selectedInterestUser"
                ref="linkContentModal"
                :interest="selectedInterestUser.interest"
                :contents="contents"
                :interest-user-id="selectedInterestUser.interest_user.id"
                @selected="handleSelected"
            />

            <div v-if="successMessage" class="alert alert-success">
                {{ successMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import LinkContentModal from './LinkContentModal.vue'

export default {
    components: { LinkContentModal },

    props: ['content_interest_users', 'contents'],

    data() {
        return {
            contentInterestUsersArray: Object.values(this.content_interest_users),
            selectedInterestUser: null,
            successMessage: '',
            visibleCard: null,
            showStats: true
        }
    },

    computed: {
        hasLikes() {
        return function (content) {
            return content.latest_stat && content.latest_stat.likes !== null;
        }
        },
        hasStats() {
            return function (content) {
                return this.showStats && this.getStats(content).length > 0;
            }
        },
        latestStat() {
            return function (content) {
                return this.$get(content, 'latest_stat', {});
            }
        },
        getStats() {
            return function (content) {
                const latestStat = this.latestStat(content);
                return [
                    {
                        label: 'Visninger',
                        value: this.$get(latestStat, 'views_total'),
                    },
                    {
                        label: 'Unikke visn.',
                        value: this.$get(latestStat, 'views_unique'),
                    },
                ].filter(stat => stat.value != null);
            }
        }
    },

    methods: {
        openModal(interestUser) {
            this.selectedInterestUser = interestUser
            this.$nextTick(() => {
                this.$refs.linkContentModal.open()
            })
        },
        toggleCardBody(id) {
            const cards = this.$refs.card;
            cards.forEach(card => {
                if (parseInt(card.dataset.id) === id) {
                    if (card.classList.contains('active')) {
                        card.classList.remove('active');
                        this.visibleCard = null;
                    } else {
                        card.classList.add('active');
                        this.visibleCard = id;
                    }
                } else {
                    card.classList.remove('active');
                }
            });
        },

        handleSelected(selectedContents) {
            const interestUserId = this.selectedInterestUser.interest_user.id
            const interestUser = this.contentInterestUsersArray.find(item => item.interest_user.id === interestUserId)
            if (interestUser) {
                interestUser.content = selectedContents
                this.successMessage = 'Contents attached successfully.'
                setTimeout(() => {
                    this.successMessage = ''
                }, 3000)
            }
        }
    }
}
</script>

<style lang="less" type="text/less">
.card-img-top {
    height: 80px;
    object-fit: cover;
}
.PageHeader__pledge {
    h1 {
        font-size: 40px;
        font-style:normal;
    }
}
.bg-pledge {
    position: relative;
    &::after {
        position: absolute;
        content: "";
        top: -1px;
        left: 0;
        right: -1px;
        left: 20%;
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 48%);
        background-color: #fff;
        z-index: 9;
        height: 37px;
    }
    .text-xl {
        font-size: 22px;
        line-height: 30px;
    }
}
.connect-your-works {
    padding-top: 40px;
    padding-bottom: 120px;
    position: relative;
    &::before {
       position: absolute;
        content: "";
        top: -1px;
        right: -1px;
        left: -1px;
        clip-path: polygon(100% 0, 0 0, 100% 100%);
        background-color: #fff;
        z-index: 9;
        height: 100px;

    }
    &::after {
        position: absolute;
        content: "";
        bottom: -2px;
        right: -2px;
        left: -1px;
        clip-path: polygon(0 0, 0 100%, 100% 100%);
        background-color: #fff;
        z-index: 9;
        height: 100px;

    }
    .bg-white {
        position: relative;
        &::before {
            position: absolute;
            content: "";
            top: -1px;
            right: -1px;
            left: 20%;
            clip-path: polygon(100% 0, 0 0, 100% 100%);
            background-color: #ff00a8;
            z-index: 9;
            height: 50px;

        }
        &::after {
            position: absolute;
            content: "";
            bottom: -2px;
            right:20%;
            left: -1px;
            clip-path: polygon(0 0, 0 100%, 100% 100%);
            background-color: #ff00a8;
            z-index: 9;
            height: 50px;

        }
    }
    .active {
        .card-header::after {
            content: "\f068";
        }
        .card-body {
            display: block !important;
        }
    }
    .card-header {
        position: relative;
        &::after {
            position: absolute;
            content: "\f067";
            font-family: "FontAwesome";
            right: 0;
            bottom: 20px;
            padding: 10px 12px;
            border-radius: 50%;
            color: #ff00a8;
            border: solid 1px #ff00a8;
            line-height: 1em;

        }
    }
    ul { 
        margin-left: -15px;
        margin-right: -15px;
        row-gap: 20px;
        li {
            width: 190px;  
            padding: 10px 15px; 
            .wrapper-img {
                position: relative;
                padding-top: 150%;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
            }
            .columns-3 {

            }
        }
    }
}
@media ( min-width:768px) and (max-width: 1360px) {
    .pledge-content {
        .block-title {
            font-size: 8vw;
            img {
                width: 8vw;
                height: auto;
            }
        }
    }
//    .connect-your-works ul li {
//        width: 33.3%;
//    }
}
@media( max-width: 767px) {
    .pledge-content {
        .block-title {
            font-size: 21vw;
            img {
                width: 21vw;
                height: auto;
            }
        }
    }
//    .connect-your-works ul li {
//        width: 50%;
//    }
    .connect-your-works .bg-white::before,
    .connect-your-works .bg-white::after {
        height: 25px;
    }
    .connect-your-works::before,
    .connect-your-works::after {
        height: 40px;
    }
}
</style>
